export enum TOUR_TYPE {
  Flights_only = "flights_only",
  Umrah = "umrah",
}

export enum TOUR_TYPES {
  FLIGHTS_ONLY = "FLIGHTS_ONLY",
  UMRAH = "UMRAH",
}
